import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue'
import MainTracker from '../pages/MainTracker.vue'
import GroupsPage from '../pages/GroupsPage.vue'
import SettingsPage from '../pages/SettingsPage.vue'
import UsersPage from '../pages/UsersPage.vue'
import SystemPage from '../pages/SystemPage.vue'
import { useAuth } from '../composables/useAuth'
import { API } from '../api/client'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainTracker,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: SettingsPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/groups',
      name: 'groups',
      component: GroupsPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'users',
      component: UsersPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/system',
      name: 'system',
      component: SystemPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    // Redirect any unmatched routes to home
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

// Navigation guard to check authentication
router.beforeEach(async (to, _from, next) => {
  const { isAuthenticated, initializeAuth, logout, clearMemoryState } = useAuth()

  // Initialize auth state if not already done
  await initializeAuth()

  if (to.path === '/login' && isAuthenticated.value) {
    next('/')
    return
  }

  if (to.meta.requiresAuth) {
    if (!isAuthenticated.value) {
      next('/login')
      return
    }

    try {
      await API.getCurrentUser()
      next()
    } catch (error: unknown) {
      const axiosError = error as { response?: { status?: number } }
      if (axiosError?.response?.status === 401) {
        // Session is genuinely dead — full cleanup including server-side
        // revocation of the refresh token.
        logout()
      } else {
        // Transient error (network, 5xx, etc.) — keep the session in
        // localStorage so it can be recovered later (e.g. after a page
        // reload or a future retry mechanism). Only clear in-memory state
        // to avoid a redirect loop back to the protected route.
        clearMemoryState()
      }
      next('/login')
    }

    return
  }

  next()
})

export default router